import { Box, Flex, Title } from '@mantine/core'

import type { AccountTypeProps } from '@/modules/accounts/components/AccountType/AccountType.props'

import classes from './AccountType.module.css'

export function AccountType({
  accountType,
  formattedBalance,
}: AccountTypeProps) {
  return (
    <Box className={classes.leftColumn}>
      <Flex align="center">
        {accountType.icon && <accountType.icon />}

        <Title mb={0} variant="h2">
          {accountType.label}
        </Title>
      </Flex>

      <Title mt={16} variant="h1">
        {formattedBalance}
      </Title>
    </Box>
  )
}
